// import React from 'react';

// const KanthasriLoader = ({ text = "Stitching..." }) => {
//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-[#fdfbf7]">
//       {/* Simple Pulsing Stitch */}
//       <div className="relative flex items-center justify-center w-16 h-16">
//         {/* The "Needle Point" */}
//         <div className="w-3 h-3 bg-[#294060] rounded-full z-10"></div>
        
//         {/* The Ripple (Stitch effect) */}
//         <div className="absolute inset-0 border-2 border-[#d4af37] rounded-full animate-ping opacity-25"></div>
//         <div className="absolute inset-4 border border-[#294060] rounded-full animate-pulse opacity-20"></div>
//       </div>

//       {/* Brand Text */}
//       <div className="mt-6 text-center">
//         <h2 className="text-[#294060] font-serif text-xl tracking-[0.3em] uppercase font-light">
//           Kanthasri
//         </h2>
//         <p className="text-[#d4af37] text-xs italic mt-1 tracking-widest animate-pulse">
//           {text}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default KanthasriLoader;

import React from 'react';

const KanthasriLoader = ({ text = "Weaving your story..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#fdfbf7]">
      <div className="relative w-24 h-24 flex items-center justify-center">
        {/* Animated Stitching Circle */}
        <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90">
          {/* Subtle background track (The Fabric) */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="1"
            strokeDasharray="4 4"
            className="opacity-50"
          />
          
          {/* The Running Stitch (The Thread) */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#294060"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="10 15"
            className="animate-[dash_3s_linear_infinite]"
          />
        </svg>

        {/* Floating Needle Icon */}
        <div className="absolute flex items-center justify-center animate-bounce">
           <div className="w-1 h-8 bg-gradient-to-b from-[#d4af37] to-transparent rounded-full transform rotate-45" />
        </div>
      </div>

      {/* Brand & Loading Text */}
      <div className="mt-8 text-center">
        <h2 className="text-[#294060] font-serif text-2xl tracking-[0.4em] uppercase font-light mb-2">
          Kanthasri
        </h2>
        <div className="flex items-center justify-center space-x-2">
          <span className="h-[1px] w-8 bg-[#d4af37]/40"></span>
          <p className="text-[#d4af37] text-xs italic tracking-[0.2em] uppercase font-medium">
            {text}
          </p>
          <span className="h-[1px] w-8 bg-[#d4af37]/40"></span>
        </div>
      </div>

      {/* Custom Animation Keyframes (Add this to your globals.css or Tailwind config) */}
      <style jsx>{`
        @keyframes dash {
          to {
            stroke-dashoffset: -250;
          }
        }
      `}</style>
    </div>
  );
};

export default KanthasriLoader;